<div class="application-dialog-aligned-commitments-part">
	<grid-content [setup]="setup" [namedSize]="'CustomHeight'" [customHeight]="customHeight()"
		[rows]="alignedCommitments()"></grid-content>
</div>